/**
 * Un archivo cuenta como CSV si su extensión termina en .csv, o si el navegador le asignó un
 * `type` de CSV/Excel — Windows exporta CSV a veces como `application/vnd.ms-excel`.
 */
export function isCsvFile(file: File): boolean {
  return file.name.toLowerCase().endsWith('.csv')
    || file.type === 'text/csv'
    || file.type === 'application/vnd.ms-excel';
}
